import { getAllCountryCode, getDefaultPostalCode } from '@cimpress-technology/default-postal-codes';

export const getDefaultPostalCodeOrEmpty = (country: string) => {
  if (!getAllCountryCode().includes(country)) {
    return '';
  }
  return getDefaultPostalCode(country);
};
